import { render, staticRenderFns } from "./HistoricalBookings.vue?vue&type=template&id=043858f5"
import script from "./HistoricalBookings.vue?vue&type=script&lang=js"
export * from "./HistoricalBookings.vue?vue&type=script&lang=js"
import style0 from "./HistoricalBookings.vue?vue&type=style&index=0&id=043858f5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports